import { render, staticRenderFns } from "./packages-picker.vue?vue&type=template&id=019d8dce&"
import script from "./packages-picker.vue?vue&type=script&lang=js&"
export * from "./packages-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports